import styles from './Loader.module.scss';

enum loaderType {
    SPINNER = 'SPINNER',
    SMALL_SPINNER = "SMALL_SPINNER",
    BUBBLES = 'BUBBLES'
}

type LoaderProps = {
    type: string;
    yellowBubbles?: boolean;
}

const Loader: React.FC<LoaderProps> = ({type, yellowBubbles}) => {
    return (
        <>
            {type === loaderType.BUBBLES && <div className={`${styles.bubblesLoader} ${yellowBubbles ? styles.yellowBubbles: styles.whiteBubbles}`} />}
            {type === loaderType.SPINNER && <div className={styles.spinnerLoader} />}
            {type === loaderType.SMALL_SPINNER && <div className={styles.smallSpinnerLoader} />}
        </>
    );
}

export default Loader;
